import { db } from "@/firebase";
import firebase from "firebase/app";

export const state = {
  clients: [],
  currentClient: null
};
export const mutations = {
  SET_CLIENT(state, clientData) {
    if (state.clients == null) {
      state.clients = [];
    }
    state.clients.push(clientData);
  },
  SET_CURRENT_CLIENT(state, clientData) {
    state.currentClient = clientData;
  },
  EDIT_CLIENT(state, newData) {
    state.clients.find((c, index) => {
      if (c.id == newData.id) {
        state.clients[index] = { ...newData };
      }
    });
  },
  REMOVE_CLIENT(state, clientIdToRemove) {
    state.clients.find((c, index) => {
      if (c.id == clientIdToRemove) {
        state.clients.splice(index, 1);
      }
    });
  },
  ADD_NEW_NOTE(state, newNote) {
    state.currentClient.notes.unshift(newNote);
  },
  UPDATE_NOTES_FROM_CURRENT_USER(state, newNote) {
    let tempNote = {
      id: newNote.id,
      title: newNote.title,
      description: newNote.description,
      date: newNote.date
    };
    state.currentClient.notes.find((n, index) => {
      if (n.id == tempNote.id) {
        state.currentClient.notes[index] = { ...tempNote };
      }
    });
  }
};

export const actions = {
  loadAllClients({ commit }) {
    if (state.clients.length < 1) {
      db.collection("clients").onSnapshot(querySnapshot => {
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added") {
            let tempClient = {
              id: change.doc.id,
              ...change.doc.data()
            };
            commit("SET_CLIENT", tempClient);
          }
        });
      });
    }
  },
  deleteClient({ commit }, id) {
    return db
      .collection("clients")
      .doc(id)
      .delete()
      .then(() => {
        commit("SET_CURRENT_CLIENT", null);
        commit("REMOVE_CLIENT", id);
      });
  },
  createNewClient() {
    let tempClient = {
      creationDate: new Date(),
      email: "",
      name: "",
      nif: "",
      state: "lead",
      website: []
    };
    return db
      .collection("clients")
      .add(tempClient)
      .then(docRef => {
        console.log("Document written with ID: ", docRef.id);
        return docRef;
      })
      .catch(error => {
        console.error("Error adding document: ", error);
      });
  },
  updateClient({ commit, dispatch }, client) {
    const { id, agents, notes, ...updatedClient } = client;
    let docRef = db.collection("clients").doc(id);
    docRef
      .update(updatedClient)
      .then(() => {
        let tempCli = { id, ...updatedClient };
        commit("EDIT_CLIENT", tempCli);
        docRef
          .collection("agents")
          .get()
          .then(querySnapshot => {
            let diff = agents.length - querySnapshot.size;
            if (diff > 0) {
              for (
                let i = querySnapshot.size;
                i < querySnapshot.size + diff;
                i++
              ) {
                docRef.collection("agents").add(agents[i]);
              }
            }
            commit("SET_CURRENT_CLIENT", client);
            const notification = {
              type: "success",
              message: "Client updated"
            };
            dispatch("notification/add", notification, { root: true });
          });
      })
      .catch(function(error) {
        console.error("Error updating document: ", error);
      });
  },
  loadCurrentClient({ commit }, id) {
    let tempClient = null;
    let docRef = db.collection("clients").doc(id);
    return docRef.get().then(doc => {
      tempClient = { id, ...doc.data(), agents: [], notes: [] };
      return docRef
        .collection("agents")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(agent => {
            tempClient.agents.push(agent.data());
          });
          return docRef
            .collection("notes")
            .orderBy("date", "desc")
            .get()
            .then(querySnapshot => {
              querySnapshot.forEach(note => {
                let tempNote = {
                  id: note.id,
                  ...note.data(),
                  editNote: true
                };
                tempClient.notes.push(tempNote);
              });
              commit("SET_CURRENT_CLIENT", tempClient);
            });
        });
    });
  },
  createNewNote({ commit, dispatch }, payload) {
    let clientRef = db.collection("clients").doc(payload.clientId);
    return clientRef
      .collection("notes")
      .add(payload.note)
      .then(docRef => {
        let newNote = {
          id: docRef.id,
          ...payload.note,
          date: firebase.firestore.Timestamp.fromDate(payload.note.date),
          editNote: true
        };
        commit("ADD_NEW_NOTE", newNote);
        const notification = {
          type: "success",
          message: "Note created"
        };
        dispatch("notification/add", notification, { root: true });
        return docRef;
      })
      .catch(error => {
        console.error("Error adding document: ", error);
      });
  },
  updateNote({ commit, dispatch }, payload) {
    const { id, editNote, ...updatedNote } = payload.note;
    let docRef = db.collection("clients").doc(payload.clientId);
    docRef
      .collection("notes")
      .doc(id)
      .update(updatedNote)
      .then(() => {
        commit("UPDATE_NOTES_FROM_CURRENT_USER", payload.note);
        const notification = {
          type: "success",
          message: "Note updated"
        };
        dispatch("notification/add", notification, { root: true });
      });
  }
};

export const getters = {
  getClients(state) {
    if (state.clients != null) return state.clients;
    else return null;
  },
  getClientById: state => idClient => {
    return state.clients.find(c => c.id == idClient);
  },
  getCurrentClient(state) {
    if (state.currentClient != null) return state.currentClient;
    else return null;
  },
  getCurrentClientNotes(state) {
    return state.currentClient.notes;
  }
};
